import { AlertPriority, AlertStatus, ProbableCause } from 'types'
import {
  RolodexEntryIndexType,
  RolodexEntryJson,
} from 'types/rolodex/rolodexEntries'
import {
  parseArray,
  parseBoolean,
  parseNumber,
  parseString,
} from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

// TODO: Need to have an actual gecko ai agent to get the explanations and causes
// TODO: have an expected range of values for a sensor, maybe this should be on the datapoint entry
export type GeckoAlertData = {
  priority: AlertPriority
  timestamp: string
  acknowledged: boolean
  status: AlertStatus
  alerted_value: number
  setpoint: number
  ai_explanation?: string
  probable_causes?: ProbableCause[]
}

export class GeckoAlert extends GeckoEntryBase<
  GeckoAlertData,
  {
    organization: string
    site: string
    unit: string
    datapoints: string
  },
  RolodexEntryIndexType
> {
  constructor(json: RolodexEntryJson) {
    const data: GeckoAlertData = {
      priority: (parseNumber(json.data.priority) ?? 2) as AlertPriority,
      timestamp: json.data.timestamp as string,
      acknowledged: parseBoolean(json.data.acknowledged) ?? false,
      status: (parseString(json.data.status) ?? 'Normal') as AlertStatus,
      alerted_value: parseNumber(json.data.alerted_value) ?? 0,
      setpoint: parseNumber(json.data.setpoint) ?? 0,
      ai_explanation: parseString(json.data.ai_explanation),
      probable_causes: parseArray(json.data.probable_causes) as
        | ProbableCause[]
        | undefined,
    }

    const tags = {
      organization: parseString(json.tags.organization) ?? '',
      site: parseString(json.tags.site) ?? '',
      unit: parseString(json.tags.unit) ?? '',
      datapoints: parseString(json.tags.datapoints) ?? '',
    }

    super(json, data, tags, {})
  }
}
